import React, { useEffect } from "react";
import { observer } from "mobx-react";
import ConnectLinkedInButton from "./ConnectLinkedInButton";
import { linkedInReplyState } from "./state";
import ConnectedLinkedInList from "./ConnectedLinkedInList";
import ConnectedLinkedInConfigure from "./ConnectedLinkedInConfigure";
import PaywallUtils from "Utils/PaywallUtils";
import userDetail from "Stores/userDetail";

const LinkedInAccounts = observer((props = {}) => {
  const { liAutomationEnabled = false } = userDetail?.userFeatureFlag || {};
  useEffect(() => {
    linkedInReplyState.setLinkedInDataLoading(true);
    linkedInReplyState.getLinkedInAccounts();

    if (!liAutomationEnabled) {
      PaywallUtils.upgradeUtilsFunction("linkedInAutomationNotEnabled", false);
    }
  }, [liAutomationEnabled]);

  // The Unipile OAuth flow redirects the popup it opened back to this same
  // page on both success and cancel. Tell the opener we're done, then close
  // this window - but only when this really is that popup (window.opener
  // set). Closing unconditionally blanked a normal visit to this tab in
  // embeddings where the browser doesn't block script-close on a
  // non-script-opened window (e.g. this page inside an iframe).
  useEffect(() => {
    if (window.opener && window.opener !== window) {
      try {
        window.opener.postMessage({ type: "LINKEDIN_OAUTH_POPUP_DONE" }, "*");
      } catch (e) {
        // ignore
      }
      const timer = setTimeout(() => window.close(), 300);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div
      className={`connectLinkedInBody ${
        linkedInReplyState?.linkedInConnected ? "linkedInAccountConnected" : ""
      }`}
    >
      {linkedInReplyState?.linkedInConnected ? (
        linkedInReplyState?.showConfigure ? (
          <ConnectedLinkedInConfigure />
        ) : (
          <div className="connectedLinkedInAccountsBody">
            {/* <ConnectedLinkedInHeader /> */}
            <ConnectedLinkedInList />
          </div>
        )
      ) : (
        <ConnectLinkedInButton />
      )}
    </div>
  );
});

export { LinkedInAccounts };
export default LinkedInAccounts;
